import * as moment from "moment-timezone";
import { getOption, subscribeToOption } from "../../Utilities/Platform/Options/Options";
import { Bootstrapper } from "../Bootstrapper";

export class LocaleBootstrapper extends Bootstrapper {
    /**
     * Handle changes to the timezone
     */
    protected changeTimezone(timezone?: string): void {
        if(!timezone) {
            // Set to local machines timezone
            moment.tz.setDefault();
        } else {
            // Set to settings timezone
            moment.tz.setDefault(timezone);
        }
    }

    /**
     * Handle changes to the start of the week
     */
    protected changeStartOfWeek(value: string | number): void {
        let start = value;

        if(typeof value === "string") {
            start = moment.weekdays().indexOf(value.charAt(0).toUpperCase() + value.slice(1));
        }

        if(start === -1) {
            start = 0;
        }

        moment.updateLocale(moment.locale(), {
            week: {
                dow: start as number,
                doy: 4,
            },
        });
    }

    /**
     * Determine the current time using the UTC offset from the server
     */
    protected getCurrentTime(): number {
        return Date.now() - getOption("utc_offset");
    }

    /**
     * @inheritDoc
     */
    public bootstrap(): void {
        const timezone = subscribeToOption("timezone", (_, newValue) => {
            this.changeTimezone(newValue);
        });

        const startOfWeek = subscribeToOption("start_of_week", (_, newValue) => {
            this.changeStartOfWeek(newValue);
        });

        this.changeTimezone(timezone);
        this.changeStartOfWeek(startOfWeek);

        // Use the server's time instead of the computer's time
        // The bad typing is due to Moment having this set as a read-only property
        (moment as {
            /**
             * Get the current time
             */
            now: () => number;
        }).now = this.getCurrentTime;
    }
}
